(function($) {
	$(function() {
		let reveal_share_buttons = document.getElementsByClassName(
			'js-share-reveal'
		);
		let hide_share_buttons = document.getElementsByClassName(
			'js-share-hide'
		);

		function showShareLinks(event) {
			let parentTile = event.target.parentNode;
			let shareIcons = parentTile.querySelector('.js-share-icons');

			if (
				!parentTile.classList.contains('tile') ||
				shareIcons.length === 0
			) {
				return false;
			}

			event.target.blur();
			parentTile.classList.add('tile--share-overlay');
			shareIcons.classList.add('share-icons--overlay');

			$('html, body').animate(
				{ scrollTop: parseInt($(parentTile).offset().top) },
				1000
			);
		}

		function hideShareLinks(event) {
			let parentTile = event.target.parentNode;
			let shareIcons = parentTile.querySelector('.js-share-icons');

			if (
				!parentTile.classList.contains('tile') ||
				shareIcons.length === 0
			) {
				return false;
			}

			parentTile.classList.remove('tile--share-overlay');
			shareIcons.classList.remove('share-icons--overlay');
		}

		if (reveal_share_buttons.length > 0) {
			for (var i = 0, len = reveal_share_buttons.length; i < len; i++) {
				reveal_share_buttons[i].addEventListener(
					'click',
					showShareLinks
				);
			}
		}

		if (hide_share_buttons.length > 0) {
			for (var i = 0, len = hide_share_buttons.length; i < len; i++) {
				hide_share_buttons[i].addEventListener('click', hideShareLinks);
			}
		}
	});
})(jQuery);
